import VlocHistory from 'features/lineOfCredit/screens/history/VlocHistory';
import React from 'react';

export default function Page() {
  return <VlocHistory />;
}
